import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { sendToGTM } from '../context/utils/GoogleTagManager';
export var formComplete = function formComplete(props) {
  var identifier = props.identifier,
      name = props.name,
      partySize = props.partySize;
  var event = {
    event: 'form_complete',
    detailed_event: 'Form Complete',
    event_data: _objectSpread({
      identifier: identifier ? identifier : '',
      name: name ? name : ''
    }, partySize && {
      party_size: partySize
    })
  };
  sendToGTM({
    data: event
  });
};